import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";

import DashboardHolder from "components/Next/Dashboard/DashboardHolder";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

class DashboardHolderContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <DashboardHolder {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);

  return {};
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);
  const projectId = nextReducer.getProjectId(state, id);

  return {
    datasets: homeReducer.getSimilarDatasets(state, datasetId),
    tempDatasetId: nextReducer.getTempDatasetId(state, id),
    comparisonOptions: nextReducer.getComparisonOptions(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DashboardHolderContainer);
